var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10Unabletomove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_299_356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#F90903"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 162.441C290 191 316.325 226.277 323 278.191C285 273 242 273.441 200 273.441C156 273.441 112.989 271.758 78 279.441C81.7523 219.204 113.636 182.277 153 162.441C185.085 146.273 216 147 245 162.441Z",
    fill: "#302F2F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307 264C307 277.001 243.287 267 198 267C152.713 267 92 279 92 260.999C92 250.994 164.393 231.984 198 231.984C231.607 231.984 307 250.999 307 264Z",
    fill: "#DDC2C2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 100C74.5542 87.9828 81.3132 83.1051 96 76",
    stroke: "black",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334 100C325.446 87.9828 318.687 83.1051 304 76",
    stroke: "black",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5299 129.888C56.6055 130.298 56.679 130.719 56.749 131.149C57.5497 136.066 57.7358 141.193 56.4926 144.609C54.9508 148.845 53.4912 150.154 52.7618 150.548C52.2144 150.844 51.2599 151.066 49.1069 150.282C46.9539 149.499 46.3653 148.715 46.1359 148.137C45.8304 147.366 45.5539 145.425 47.0957 141.189C48.3389 137.773 51.777 133.965 55.551 130.713C55.881 130.429 56.2081 130.153 56.5299 129.888Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2365 132.36C51.1998 130.223 56.0048 132.209 54.2584 135.086L48.1235 146.385C44.8381 148.191 43.5804 146.61 43.1016 143.659L49.2365 132.36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.0412 171.489C29.1869 171.88 29.3324 172.283 29.4761 172.694C31.1184 177.397 32.192 182.414 31.5608 185.994C30.778 190.433 29.5679 191.976 28.9181 192.49C28.4303 192.877 27.5288 193.261 25.2724 192.863C23.016 192.465 22.3003 191.796 21.9741 191.266C21.5394 190.56 20.9299 188.697 21.7128 184.257C22.3439 180.677 25.0686 176.33 28.2205 172.473C28.4962 172.135 28.7704 171.807 29.0412 171.489Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2872 175.189C23.8496 172.744 28.9265 173.865 27.7061 177.002L23.6265 189.195C20.7046 191.543 19.1915 190.205 18.2075 187.382L22.2872 175.189Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5039 223.355C15.7154 223.714 15.9285 224.085 16.1414 224.465C18.5755 228.812 20.5039 233.566 20.5039 237.201C20.5039 241.709 19.5801 243.438 19.0295 244.058C18.6162 244.523 17.7951 245.058 15.5039 245.058C13.2127 245.058 12.3917 244.523 11.9783 244.058C11.4277 243.438 10.5039 241.709 10.5039 237.201C10.5039 233.566 12.4323 228.812 14.8664 224.465C15.0793 224.085 15.2924 223.714 15.5039 223.355Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49491 228.17C10.6091 225.491 15.8036 225.714 15.1464 229.015L13.246 241.73C10.7763 244.551 9.05375 243.495 7.59451 240.886L9.49491 228.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.982 129.888C341.906 130.298 341.833 130.719 341.763 131.149C340.962 136.066 340.776 141.193 342.019 144.609C343.561 148.845 345.021 150.154 345.75 150.548C346.297 150.844 347.252 151.066 349.405 150.282C351.558 149.499 352.146 148.715 352.376 148.137C352.681 147.366 352.958 145.425 351.416 141.189C350.173 137.773 346.735 133.965 342.961 130.713C342.631 130.429 342.304 130.153 341.982 129.888Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.275 132.36C347.312 130.223 342.507 132.209 344.253 135.086L350.388 146.385C353.674 148.191 354.931 146.61 355.41 143.659L349.275 132.36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.471 171.489C369.325 171.88 369.179 172.283 369.036 172.694C367.393 177.397 366.32 182.414 366.951 185.994C367.734 190.433 368.944 191.976 369.594 192.49C370.081 192.877 370.983 193.261 373.239 192.863C375.496 192.465 376.211 191.796 376.538 191.266C376.972 190.56 377.582 188.697 376.799 184.257C376.168 180.677 373.443 176.33 370.291 172.473C370.016 172.135 369.741 171.807 369.471 171.489Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.225 175.189C374.662 172.744 369.585 173.865 370.806 177.002L374.885 189.195C377.807 191.543 379.32 190.205 380.304 187.382L376.225 175.189Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.008 223.355C382.796 223.714 382.583 224.085 382.37 224.465C379.936 228.812 378.008 233.566 378.008 237.201C378.008 241.709 378.932 243.438 379.482 244.058C379.896 244.523 380.717 245.058 383.008 245.058C385.299 245.058 386.12 244.523 386.533 244.058C387.084 243.438 388.008 241.709 388.008 237.201C388.008 233.566 386.079 228.812 383.645 224.465C383.432 224.085 383.219 223.714 383.008 223.355Z",
    stroke: "#8AF1F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_299_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.017 228.17C387.903 225.491 382.708 225.714 383.365 229.015L385.266 241.73C387.735 244.551 389.458 243.495 390.917 240.886L389.017 228.17Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_299_356",
    x: -5,
    y: -5,
    width: 405,
    height: 405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_299_356",
    x: 78,
    y: 150.586,
    width: 250,
    height: 133.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_299_356",
    x: 60,
    y: 69.998,
    width: 47.001,
    height: 41.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_299_356",
    x: 297.999,
    y: 69.998,
    width: 47.001,
    height: 41.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_299_356",
    x: 39.1016,
    y: 127.463,
    width: 19.5322,
    height: 23.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_299_356",
    x: 14.208,
    y: 169.861,
    width: 17.6855,
    height: 24.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_299_356",
    x: 3.59473,
    y: 222.332,
    width: 15.6094,
    height: 25.0723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_299_356",
    x: 339.878,
    y: 127.463,
    width: 19.5322,
    height: 23.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_299_356",
    x: 366.618,
    y: 169.861,
    width: 17.6855,
    height: 24.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_299_356",
    x: 379.308,
    y: 222.332,
    width: 15.6094,
    height: 25.0723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_299_356"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Unabletomove);
export default __webpack_public_path__ + "static/media/10. unable to move.dacf122a4c5cdfff0d7a674da44fcb11.svg";
export { ForwardRef as ReactComponent };